
<p-autoComplete class="ui-fluid"
                [ngModel]="selectedCompany"
                (ngModelChange)="onModelChange($event)"
                [suggestions]="companies"
                (completeMethod)="search($event)"
                field="name"
                [dropdown]="true"
                [forceSelection]="true"
                [showClear]="selectedCompany != null"
                placeholder="Company">
  <ng-template let-company pTemplate="item">
    {{company.name}}
  </ng-template>
</p-autoComplete>
